import { Input, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import { Form, Field, Formik } from "formik";
import CryptoJS from "crypto-js";
import { useState } from "react";

import { JsonView, darkStyles, defaultStyles } from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";
import { decryptByText, responseDataFormate } from "./bycrypt";

const CryptoFunction: React.FC = () => {
  const [decryptedTextResult, setDecryptedTextResult] = useState("");
  const [decryptedDataResult, setDecryptedDataResult] = useState("");

  const modifySecretKey = (key: string) => {
    return CryptoJS.SHA256(key).toString(CryptoJS.enc.Hex); // Ensure it's a string
  };

  const encrypt = (text: string, secretKey: string) => {
    const key = modifySecretKey(secretKey);
    const iv = CryptoJS.enc.Utf8.parse("678025308de70905");
    const encrypted = CryptoJS.AES.encrypt(text, CryptoJS.enc.Hex.parse(key), {
      iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    }).toString();
    return encrypted;
  };

  const decrypt = (text: string, secretKey: string) => {
    if (!text) return "";
    try {
      const key = modifySecretKey(secretKey);
      const iv = CryptoJS.enc.Utf8.parse("678025308de70905");
      const decrypted = CryptoJS.AES.decrypt(
        text,
        CryptoJS.enc.Hex.parse(key),
        {
          iv,
          padding: CryptoJS.pad.Pkcs7,
          mode: CryptoJS.mode.CBC,
        },
      );
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting:", error);
      return "";
    }
  };

  const handleSave = async (values: any) => {
    if (values?.encryptedText) {
      const newData = decryptByText(values?.encryptedText);
      setDecryptedTextResult(newData);
    }
    if (values?.encryptedData) {
      const newData = responseDataFormate(values?.encryptedText);
      setDecryptedDataResult(newData);
    }
  };

  const handleCopy = (text: string) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    message.success("Copied ! ");
  };

  return (
    <div className="py-3 px-40 d-flex flex-column flex-fill overflow-y-auto">
      <div className="d-flex flex-wrap gap-3 justify-content-center mb-4">
        <h1 className="fw-bold admin-page-title mb-0">Crypto JS</h1>
      </div>

      <div className="modal-body page-form overflow-hidden">
        <Formik
          initialValues={{
            encryptedText: "",
            encryptedData: "",
          }}
          onSubmit={handleSave}
        >
          {({ handleChange, handleSubmit }) => (
            <div className="row d-flex justify-content-center">
              <Form onSubmit={handleSubmit} className="row col-7">
                <div className="col-12 mt-3">
                  <div className="form-item">
                    <label className="custom-label mb-1 ff">Decrypt Text</label>
                    <Field
                      name="encryptedText"
                      placeholder="Enter Encrypted Text"
                      as={Input}
                    />
                  </div>
                </div>
                <div
                  className="col-12 mt-3 text-white p-3 rounded"
                  style={{
                    minHeight: "70px",
                    width: "97%",
                    marginLeft: "15px",
                    background: "#002b36",
                  }}
                >
                  <div className="form-item d-flex justify-content-between">
                    {decryptedTextResult && (
                      <span className="">{decryptedTextResult}</span>
                    )}
                    {decryptedTextResult && (
                      <button
                        className="btn btn-sm btn-light"
                        onClick={() => handleCopy(decryptedTextResult)}
                      >
                        Copy
                      </button>
                    )}
                  </div>
                </div>
                <div className="col-12 mt-3">
                  <div className="form-item">
                    <label className="custom-label mb-1 ff">Decrypt Data</label>
                    <Field
                      name="encryptedData"
                      placeholder="Enter Encrypted Data"
                      as={TextArea}
                      rows={8}
                    />
                  </div>
                </div>

                <div
                  className="col-12 mt-3 text-white p-3 rounded"
                  style={{
                    minHeight: "200px",
                    width: "97%",
                    marginLeft: "15px",
                    overflow: "auto",
                    maxHeight: "700px",
                    position: "relative",
                    background: "#002b36",
                  }}
                >
                  {decryptedDataResult ? (
                    <>
                      <div
                        style={{
                          position: "sticky",
                          top: 0,
                          right: 0,
                          zIndex: 10,
                          padding: "4px",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <button
                          className="btn btn-sm btn-light"
                          style={{ height: "40px" }}
                          onClick={() => handleCopy(decryptedDataResult)}
                        >
                          Copy
                        </button>
                      </div>
                      <div>
                        <JsonView
                          data={JSON.parse(decryptedDataResult)}
                          // shouldInitiallyExpand={(level:any) => true}
                          style={darkStyles}
                        />
                      </div>
                      {/* <pre
                        style={{
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                        }}
                      >
                        {JSON.stringify(
                          JSON.parse(decryptedDataResult),
                          null,
                          2
                        )}
                      </pre> */}
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div className="d-flex justify-content-center mt-5">
                  <button type="submit" className="btn btn-lg btn-primary">
                    Update
                  </button>
                </div>
              </Form>
            </div>
          )}
        </Formik>
      </div>

      {/* Display results */}
    </div>
  );
};

export default CryptoFunction;
